export default {
    header: {
        resize: '调整尺寸',
        createInfo: '创建设计后，将新建画布，当前海报内容可在作图记录中查看。',
        okText: '确定',
        cancelText: '取消',
        designNow: '创建设计',
        download: '下载',
        PngDescribe: '无损图片，文件较大，支持透明背景',
        JpgDescribe: '文件较小，不支持透明背景',
        splitDownloadMode: '页面切片下载',
        wholeDownloadMode: '完整页面下载',
        pptFile: 'PPT文件',
        pdfFile: 'PDF文件',
        pptWithEditDesc: '以「PPT文件」可编辑格式下载，部分样式可能无法还原。在设计室平台外编辑此作品存在版权风险。',
        pptDisableEditDesc: '以「PPT文件」不可编辑格式下载，PPT将转为图片处理。',
        noCompression: '（无压缩）',
        persionUse: '个人/公益使用',
        commercialUse: '商业使用',
        waterMarkDownload: '（含水印）',
        noWaterMarkDownload: '（不含水印）',
        pptWithEditText: 'PPT 内文字可编辑',
        pptDisableEditText: 'PPT 内文字不可编辑',
        savingTip: '正在保存中 请稍后重试',
        saving: '保存中...',
        downloadFail: '下载失败，请稍后再试！',
        genImage: '正在导出${0} (${1}/${2})',
        cancel: '取消',
        selectAll: '全选',
        splitDownloadAll: '页面切片下载（全选）',
        pagesDownloadAll: '分页下载（全选）',
        pageNum: '第${0}页',
        merageDownload: '所有页面合并为长图下载',
        downloadEffectTip: '尺寸统一效果更好哦～',
        selectOneTip: '至少选择一个页面',
        longImageDownload: '长图下载',
        allPagesDownload: '所有页面',
        selectedPage: '（${0}页）',
        selectTip: '请选择页面',
        selectedCountTip: '共选择${0}页',
        commercialInfo:
            '企业商业使用：指企业、个体工商户、行政组织、社会团体等法人及非法人组织将设计成品用于自身的商业盈利行为。',
        personInfo: '个人商业使用：指自然人主体将设计成果用于以自然人为主体从事的商业盈利行为，最终受益生体也为个人。',
        welfareInfo: '公益使用：指为了宣传、推广实际发生的公益活动而使用正版内容。',
        openVipAndDownload: '开通会员免费下载',
        downloadWorks: '下载作品',
        workType: '作品类型',
        adviceDownloadType: '（建议下载类型）',
        downloadType: '下载方式',
        selectPageTip: '选择页面',
        workUseFor: '作品用途',
        agreeAndDownload: '下载即视为您阅读并同意<>用户协议</>和<>隐私协议</>',
        downloadSuccess: '作品下载成功',
        workWithCopyright: '当前作品无版权风险，可作为商业授权用途使用。',
        workWithPersonal: '当前作品仅限公益使用，商业授权用途含侵权风险。',
        toCommercial: '我要商用',
        workAutoSaved: '作品已自动保存至作图记录',
        aiWarning: '*该作品含有AI素材内容，如需商用请删除AI素材',
        view: '查看',
        clickAndDownload: '点击下载作品',
        designFileName: '未命名的设计',
        size: '尺寸',
        createCopy: '创建副本',
        file: '文件',
        backHome: '返回首页',
        undo: '撤销',
        redo: '重做',
        savedSuccess: '已保存成功',
        uploadedRecord: '作图记录已保存至项目',
        save: '保存',
        autoSaving: '自动保存中',
        newFile: '未命名的设计作品',
        saveRecord: '保存作图记录',
        disableShareTip: '当前作品因检测出违规内容，分享后将无法查看作品',
        genShareLink: '生成分享链接中...',
        shareUrWork: '分享你的作品',
        viewTip: '获得链接的所有人，可以查看你的作品',
        copied: '已复制',
        copyLink: '复制链接',
        showPPT: '演示',
        selectMode: '模式选择',
        confirm: '确认',
        title: '_编辑页_美图设计室',
        rename: '重命名',
        openVipAndEnjoyMeidou: '开通SVIP后每月赠送定量美豆',
        projectName: '海报编辑',
        shortcutKey: '快捷键',
        share: '分享',
        confirmTitle: '更新提示',
        confirmContent: '当前客户端暂不支持多画布下载，请点击立即更新安装最新客户端',
        confirmOk: '立即更新',
        confirmCancel: '去网页版，优先体验',
        confirmDemoTitle: '当前版本仅供演示使用',
        confirmDemoContent: '点击<>美图秀秀官网<>下载最新版体验完整功能',
        confirmKnown: '我知道了',
        fontPaidToFree: '成功将收费字体${0}，替换成免费字体${1}',
        toMySpace: '作品已自动保存至“我的空间”',
        posterEditor: '海报设计',
        imageEditor: '图片编辑',
        openImage: '打开图片',
        createCanvas: '新建画布',
        kindTips: '温馨提示',
        downloadConfirm: '是否下载当前图片？',
        noThanks: '不用了，谢谢',
        tryOtherImage: '图片加载失败，换张图试试吧~',
        loginToDownload: '登录账号立即下载',
        agreeAndDownloadIntl: '下载即视为您阅读并同意<>用户协议</>',
        noWaterMarkDownloadIntl: '无水印下载',
        image: '图片',
        ppt: 'PPT',
        pdf: 'PDF',
        aipptDownloadWidthWatermark: '带“美图设计室”标识',
        feedbackTip: '喜欢我们的产品吗？乐意收到您的反馈',
        writeFeedback: '去反馈',
        feedback: '意见反馈',
        savingFile: '导出完毕，下载中',
        downloadWithWatermark: '含水印下载',
        publicUse: '公益使用',
        personalCommercialUse: '个人商业使用',
        enterpriseCommercialUse: '企业商业使用',
        availableEdit: '（可编辑）',
        unavailableEdit: '（不可编辑）',
        editable_ppt: 'PPT（可编辑）',
        uneditable_ppt: 'PPT（不可编辑）',
        pptDownloadWithoutWatermark: '不含水印下载',
        commercialInfo_v1: '商业使用：指为商用目的而使用正版内容。',
        personInfo_v1: '个人使用：指为个人学习、研究或欣赏目的而使用正版内容。',
        pptDynamicBgDownloadTip: '下载自动转为静态模板，建议在线演示',
        createPPT: '创建空白PPT',
    },
    editor: {
        aiMaterial: {
            photo: 'AI照片',
            bg: 'AI背景',
            text: '图片应用中...',
            aiPhotoMaterial: {
                photoType: ' 照片品类<> (必选)<>',
                tip: '*选择匹配品类有助于更好的生成图片',
                errorText: '生成文案或者图片不能为空',
                genFail: '生成失败',
                title: '请描述照片画面或上传参考图',
                placeholder: '试试输入你想要生成的内容吧\\n例如：一根胡萝卜，红色，写实照片风格',
            },
            backgroundAiMaterial: {
                genFail: '生成失败',
                title: '您也可自定义画面内容或上传参考图：',
                placeholder: '例如：3D展台，红色',
                backgroundStyleType: '请选择背景风格<> (必选)<>',
            },
            commonComponents: {
                generate: '立即生成',
                tip: '使用该应用即表示您同意',
                protocol: '《AI创作者服务协议》',
                cancel: '取消',
                confirmText: '图片处理中，确认退出？',
                confirm: '确认',
            },
            inputContent: {
                fileType: '只支持png、jpeg、jpg格式图片',
                fileSize: '仅支持20M以内的图片',
                uploadFail: '上传文件失败',
                emptyText: '文案内容不能为空',
                require: '(必填)',
                thinkText: '帮我想文案',
                loading: '加载中...',
            },
            inputReferences: {
                refer: '参考案例:',
                effectStyle: '风格效果',
                change: '换一换',
                effectImgGenerate: '*可直接应用效果图进行生成',
                random: '随机',
                try: '尝试一下',
            },
            loadingSection: {
                imageGenerate: '图片生成中',
                exampleText: '像冰雕一样的金字塔',
                tip: ' 提示：描述越详细效果越具体，短语或句子均可',
            },
            materialList: {
                apply: '应用',
            },
        },
        aiPoster: {
            constants: {
                trimText: '不允许纯空格',
                supportLength: '${0}最多支持${1}个字哦～',
                commodity: '电商主图',
                logo: 'Logo名称',
                logoPlaceholder: '请输入Logo名称',
                logoImg: 'Logo图片',
                logoImgPlaceholder: '请上传Logo图片',
                product: '商品名',
                productPlaceholder: '请输入商品名',
                price: '价格',
                pricePlaceholder: '请输入价格',
                priceMessage: '请输入阿拉伯数字',
                marketingBenefits: '营销利益点',
                marketingBenefitsPlaceholder: '请输入营销利益点',
                sellingPoints: '商品卖点',
                sellingPoints1Placeholder: '请输入商品卖点',
                mainImg: '图片',
                mainImgPlaceholder: '请上传图片',
                sign: '日常问候',
                mainTitle: '主标题',
                mainTitlePlaceholder: '请输入主标题',
                theme: '主题',
                themePlaceholder: '请输入主题',
                subTitle: '副标题',
                subTitlePlaceholder: '请输入副标题',
                desc: '描述',
                descPlaceholder: '请输入描述',
                invitation: '活动邀请函',
                activityTheme: '活动主题',
                activityThemePlaceholder: '请输入活动主题',
                activityTime: '活动时间',
                activityTimePlaceholder: '请输入活动时间',
                activityAddress: '活动地点',
                activityAddressPlaceholder: '请输入活动地点',
                invitationContent: '邀请函内容',
                invitationContentPlaceholder: '请输入邀请函内容',
                qrCode: '二维码',
                qrCodePlaceholder: '请上传二维码',
                birthday: '生日祝福',
                bestWishes: '祝福语',
                bestWishesPlaceholder: '请输入祝福语',
                holiday: '节日祝福',
                announcement: '公告通知',
                notifyContent: '通知内容',
                notifyContentPlaceholder: '请输入通知内容',
                notifyParty: '通知方',
                notifyPartyPlaceholder: '请输入通知方',
                notifyTime: '通知时间',
                notifyTimePlaceholder: '请输入通知时间',
                recruitment: '人才招聘',
                job: '招聘岗位',
                jobPlaceholder: '请输入招聘岗位',
                salaryBenefits: '薪资待遇',
                salaryBenefitsPlaceholder: '请输入薪资待遇',
                jobRequirements: '岗位要求',
                jobRequirementsPlaceholder: '请输入岗位要求',
                more: '敬请期待',
            },
            successUploadMessage: '上传成功',
            failedUploadMessage: '上传失败，请重试',
            supportSizeImage: '仅支持${0}M以内的图片',
            require: '（必填）',
            requireMessage: '${0}不得为空',
            logoUploadMessage: 'logo图片正在上传中，请稍后',
            qrCodeUploadMessage: '二维码正在上传中，请稍后',
            imageUploadMessage: '图片正在上传中，请稍后',
            warnRequireMessage: '请填写必填项',
            confirmTitle: '更新提示',
            confirmContent: '当前客户端暂不支持多画布下载，请点击立即更新安装最新客户端',
            confirmOk: '立即更新',
            confirmCancel: '去网页版，优先体验',
            downLoad: '下载中...',
            save: '保存中...',
            fileName: '美图设计室AI海报${0}',
            fileName2: '美图设计室AI海报${0}.${1}',
            savingErrorMessage: '保存失败，请重试',
            noDataMessage: '暂无数据，请重试',
            supportSelectNum: '`仅支持选中${0}个`',
            supportBatchSelect: '仅支持批量选择${0}个海报',
            selectedNum: '已选中${0}个',
            selectAll: '全选当前页',
            downLoadBtn: '下载',
            editorBtn: '编辑',
            selectPosterType: '选择海报类型',
            back: '返回',
            try: '试一试',
            generate: '生成',
            jump: '跳转中...',
            openEditor: '打开设计师编辑器',
            cancelOriginalPicture: '取消原图',
            originalPicture: '原图',
            editor: '编辑',
            renderPosterList: {
                generateMore: '生成更多',
                support: '美图设计室 提供技术支持',
                noMore: '没有更多了~',
            },
            renderNoData: {
                noGenerate: '您当前还没生成海报',
                generate: '请在左侧输入后生成',
            },
            renderLoading: {
                generating: '正在火速生成海报中…',
                noLeave: '不要走开，马上回来',
            },
        },
        models: {
            saved: '${0} 已保存',
            autoSaving: '自动保存中...',
        },
        share: {
            noPreview: '此作品经审核含有敏感词汇或图片，无法访问',
            contactServer: '请告知分享者检查作品内容，若需了解具体审核细节可联系客服',
            permission: '抱歉，您没有权限查看该文件',
            noFound: '没找到相关分享信息',
            toMySpace: '作品已自动保存至“我的空间”',
            toShare: '作品可在“与我分享”中',
            title: '分享此作品',
            downloadBtn: '下载',
            editorBtn: '编辑',
            shareBtn: '分享',
        },
        header: {
            poster: '海报',
        },
        ppt: {
            loginAndRegister: '登录/注册',
            slogan: '一句话，10秒生成PPT',
            defaultPlaceholder: '请填写你想要的PPT主题',
            errorMessage: '系统繁忙，请稍后再试',
            innerTest: '内测',
            meidouText: '每日赠送40美豆=每日可免费生成4次',
            generate: '生成',
            pptVideoTitle: '高效解决你做PPT的思路、文案、设计难题',
            genPPt: '生成PPT中...',
            genFirstPage: '进度已完成${0}',
            new: '全新上线',
            newSlogan: '输入一句话，AI生成高质量PPT',
            page: '页',
            custom: '自定义',
            create: '免费生成大纲',
            try: '试试这些',
            noSave: '大纲内容未保存',
            noSaveTip: '返回将丢失当前大纲内容，您确定要返回吗？',
            cancel: '取消',
            confirm: '确定',
            delete: '删除',
            deleteTip: '您将删除该章节的全部内容，确定继续删除吗？',
            regenerate: '重新生成大纲',
            add: '在下方创建小节',
            addItem: '新增小节',
            outline: '大纲',
            outlineTip: '轻松编辑大纲，或保持原样继续',
            style: '模板风格',
            size: 'PPT文字内容',
            createPPT: '开始生成PPT',
            pageNumber: 'PPT页数',
            emptyMessage: '主题不可为空',
            title: '标题',
            sub_title: '子标题',
            chapter: '章节',
            addChapter: '新增章节',
            titleEmpty: '标题不可以为空',
            subTitleEmpty: '子标题不可以为空',
            chapterEmpty: '章节不可以为空',
            contentEmpty: '小节不可以为空',
            titlePlaceholder: '请输入标题',
            subTitlePlaceholder: '请输入子标题',
            chapterPlaceholder: '请输入章节',
            contentPlaceholder: '请输入内容',
            progress: '生成PPT中...',
            progressTip: '正在将您的想法变为现实',
            pptPage: 'PPT ${0}页',
            record: 'AI PPT生成记录',
            loadingText: '小美正在构思中，请稍等...',
            oneSentence: '输入一句话',
            oneSentencePlaceholder: 'AI生成高质量PPT',
            inAWord: '一句话生成',
            pasteText: '已有文本生成',
            placeholder: '粘贴您的笔记、大纲或任何文本内容可直接生成PPT',
            exceedMaxLen: '请删除超出字数限制部分',
            clickAwait: '点击频率过快，请稍后再试',
            isVipButtonText: '会员不限次数生成',
            loadMore: '加载更多',
            contentRich: 'PPT文本内容',
        },
        app: {
            fileName: '副本',
            confirmTitle: '温馨提示',
            confirmContent:
                '当前功能已升级，为了您更好的功能体验，请到官网下载最新版本使用~ 官网地址：https://pc.meitu.com',
            successMessage: '网络已重新连接',
            failedMessage: '无网络，请检查网络设置',
            disableAppText: '先打开图片，再开始操作吧',
        },
        unnamed: '未命名图片',
        noImageInClipboard: '未在剪贴板检查到图片，可直接打开图片或拖动图片到此页面打开~',
        incompatibleRecord: '当前作图记录因历史原因，无法正常加载，只能作为图片使用',
        recordNoFound: '找不到该作图记录,请重新选择',
        openImage: '打开图片',
        dragImageOr: '您也可以粘贴与拖拽图片至此页面打开或',
        createCanvas: '新建画布',
        records: '作图记录',
        trySample: '试试样片',
        support: '美图设计室 提供技术支持',
        aiShoeDesign: 'AI商品设计_美图设计室',
        commercialWeb: 'AI商拍_美图设计室',
        copyRight: '美图设计室',
    },
    stage: {
        usedCutoutCount: '已消耗${0}张抠图张数',
        cutoutWarning: '抠图张数不足',
        applyFail: '应用失败，请稍后再试',
        defaultText: '双击修改文字',
        viewImageInfo: '双击替换图片',
        addToSpaceTip: '试试右键将画布元素添加到我的空间吧～',
        copyTip: '试试复制文字样式吧～',
        AIExpendImage: 'AI扩图中',
        modifyImageTip: '按住鼠标拖动改变图片位置',
        contrast: '对比',
        repaintTip: '局部重绘中',
        paintTip: '按住鼠标移动涂抹选区',
        closePPT: '结束演示',
        pptInfo: '单击此处添加备注',
        laserPen: '激光笔',
        enable: '启用',
        disable: '禁用',
        webFullScreen: '网页全屏',
        fullScreen: '全屏',
        exit: '退出',
        filter: '滤镜',
        shapeMask: '形状蒙版',
        textEffect: '文字特效',
        paidFunction: '付费功能',
        aiEraser: '智能消除',
        restoration: '画质修复',
        aiEliminate: 'AI消除',
        paidBrush: '付费画笔',
        downloadResultBtnText: '下载',
        aiQuality: '变清晰',
        aiMatting: '智能抠图',
        losslessResizing: '无损改尺寸',
        shortcutOpera: {
            addText: '添加文字',
            text: '文字',
            image: '图片',
            brush: '画笔',
            localUpload: '本地上传',
            myPicture: '我的图片',
            line: '线条',
            arrow: '箭头',
            dash: '虚线',
            square: '矩形',
            circle: '圆形',
            triangle: '三角形',
            markup: '标注笔',
            curve: '曲线笔',
        },
        toolbar: {
            pressToView: '长按查看原图',
            contrast: '对比',
        },
        keyboard: {
            title: '键盘快捷键',
            function: '功能',
            windows: 'Windows系统',
            mac: 'Mac系统',
        },
        buyVip: {
            text: '开通会员去水印',
        },
    },
    collapse: {
        messageError: {
            requestFailed: '请求素材失败',
            networkFailed: '您的网络发生异常，无法连接服务器',
            noNetwork: '网络已断开，请联网后重试',
            heicError: 'HEIC图片解析失败，建议您转换为其他图片格式上传',
            filetypeLimit: '暂时只支持JPG/JPEG/PNG/SVG/HEIC/GIF/WEBP格式图片',
            parsingFailed: '图片解析失败，建议您转换为其他图片格式上传',
            addFailed: '添加失败，请重试~',
        },
        tips: {
            deleteTitle: '删除提示',
            deleteDesc: '删除后将无法重新找回，请谨慎操作',
            okText: '确认删除',
            cancelText: '取消',
            deleteSuccess: '删除成功',
            addSuccess: '添加成功',
            addLoading: '正在添加...',
            selected: '已选择<></>条',
            recordDeleteDesc: '删除作图记录后将无法重新找回，请谨慎操作！',
            uploadDesc: '单击上传文件或拖放',
            uploadLimit: '仅支持20M以内的图片',
            uploadMaxLimit: '仅支持批量上传10张图片',
            noContent: '暂无内容',
            corner: '角标图片',
            uploadSuccess: '上传成功',
            noMore: '没有更多了~',
            uploading: '上传中',
            sizeLimit: '最大支持 ${0} x ${1} 的图片上传',
        },
        backgroundCollapse: {
            title: '背景颜色',
            detailTitle: '背景专题详情',
            recentUsed: '常用背景',
            all: '全部',
            messageError: {
                applyFailed: '背景应用失败',
            },
            kindTips: '温馨提示',
            applyTips: '图片已修改，是否应用此效果？',
            apply: '应用',
            cancel: '取消',
            messageInfo: '当前功能仅对原图生效，已自动隐藏无法操作的内容',
        },
        brushCollapse: {
            linePen: '直线笔',
            curvePen: '曲线笔',
            shape: '形状',
            choose: '选择画笔',
            tips: {
                moveToCanvas: '移动到画布中绘制',
                firstClick: '点击开始标注',
                secondClick: '点击选择标注终点',
                thirdClick: '拖拽延长标注尺',
            },
            all: '全部',
            custom: '自定义',
            markupPen: '标注笔',
            defineCurvePen: '自定义曲线笔',
            defineLinePen: '自定义直线笔',
            penStyle: '画笔样式',
            stroke: '描边',
            free: '限免',
        },
        materialCollapse: {
            newestTitle: '最新素材',
            detailTitle: '素材专题详情',
            commonUsed: '常用素材',
            recentUsed: '最近使用',
            recentSearch: '最近搜索',
            clearRecord: '清除记录',
            hotSearch: '大家都在搜',
            all: '全部',
            more: '更多',
            colors: '颜色',
            reload: '重新加载',
            feedback: '反馈',
            searchPlaceholder: '搜索素材',
            tips: {
                noContent: '暂无内容',
                noContentDesc: '换个搜索词再试试${0}或反馈建议给我们',
                noNetwork: '网络有问题${0}重新加载试试吧',
            },
            similarTitle: '相似素材',
            viewMore: '查看更多',
            similarRecommend: '相似推荐',
            loading: '加载中...',
            similarTag: '相似标签',
        },
        mineCollapse: {
            mySpace: '我的空间',
            myRecord: '作图记录',
            reUpload: '重新上传',
            addMaterial: '添加素材',
            noRecord: '暂无作图记录，快去开始你的设计吧',
            pptPage: 'PPT ${0}页',
            multiplePage: '多页面 ${0}页',
            all: '全部',
            delete: '删除',
            exit: '退出',
            image: '图片',
            text: '文字',
            group: '组合',
            folder: '文件夹',
            records: '作图记录',
            elements: '元素',
            myShare: '与我分享',
            add: '添加',
            noneFolder: '暂无文件夹',
            collapse: '收起',
            expand: '展开',
            viewAll: '查看全部',
            type: '类型',
            noFilesYet: '尚未添加任何文件',
            upload: '上传',
            poster: '海报设计',
            imageEditor: '图片编辑',
            upGradeTipsTitle: '作图记录全新升级！',
            upGradeTipsContent: '包含该账号下所有的海报模板和图片编辑作图记录了哦～ 从编辑图片到设计海报，无缝切换～',
            upGradeTipsOk: '我知道了',
            steps: {
                content: '滤镜与调色功能合并至此处',
                okText: '我知道了',
            },
            productShoot: 'AI商拍',
            aiLogo: 'AI Logo',
            aiShoeDesign: 'AI商品设计',
            aigcRecords: '生成记录',
        },
        templateCollapse: {
            recommend: '推荐模板',
            recentView: '最近浏览',
            homePage: '首页',
            backToList: '返回列表',
            applyAllPage: '应用所有页面',
            all: '全部',
            filter: '筛选',
            feedback: '反馈',
            search: {
                placeholder: '搜索模板',
                hotSearch: '大家都在搜',
                recentSearch: '最近搜索',
                searchKeyword: '搜索”${0}”',
                clear: '清空',
            },
            tips: {
                noContent: '暂无内容',
                noContentDesc: '换个搜索词再试试${0}或反馈建议给我们',
                applyWouldReplace: '使用模板后，当前内容将会被替换',
                replaceCurrentTemplate: '替换全部页面',
                replaceCurrentPage: '替换当前页面',
                replaceAllPage: '替换所有页面',
                replaceWouldApplyNewPage: '以哪种方式打开模板？',
                replaceWouldApplyAllPage: '替换模板后，内容将应用至所有页面',
                addToNewPage: '在当前画布添加页面',
                replace: '替换',
                cancel: '取消',
                openNewTab: '打开新页面',
            },
            aippt: {
                replaceTemplateTitle: '切换模板',
                applyTemplateBtn: '切换模板',
                selectTemplateTip: '请先选择模板',
            },
        },
        teamCollapse: {
            template: '模板',
            material: '素材',
            group: '标签组',
            ungrouped: '未分组',
            backToList: '返回列表',
            applyAllPage: '应用所有页面',
            addMaterial: '添加素材',
            reUpload: '重新上传',
            importTemplate: '导入模板',
            all: '全部',
            upload: '上传',
            exit: '退出',
            delete: '删除',
            tips: {
                uploading: '上传中',
                noText: '没有文本图层',
                noTag: '组内暂无标签哦~',
                noTemplate: '暂无模板，请上传您的模板',
                parsing: '解析中',
                parseFailed: '解析失败',
                parseSuccess: '解析成功',
                reUpload: '重新上传',
                continueUpload: '继续上传',
                uploadSuccess: '上传成功',
                chooseFile: '选择文件',
                dropFileOr: '将文件拖拽到此处上传，或',
                psdImportSpecification: 'PSD文件导入规范',
                applyWouldReplace: '使用模板后，当前内容将会被替换',
                replaceCurrentTemplate: '替换当前模板',
                replaceCurrentPage: '替换当前页面',
                replaceAllPage: '替换所有页面',
                replaceWouldApplyNewPage: '替换模板后，内容将应用至新页面',
                replaceWouldApplyAllPage: '替换模板后，内容将应用至所有页面',
                addToNewPage: '添加为新页面',
                replace: '替换',
                cancel: '取消',
            },
            messageError: {
                needUploadPsd: '请上传PSD文件！',
                psdSizeLimit: 'psd文件大于600M， 请检查是否太大',
                uploadFailed: '上传失败',
                uploadFailedReTry: '上传失败，请重试',
            },
        },
        navigationCollapse: {
            createPage: '新增页面',
            addPage: '添加页面',
            copyPage: '复制页面',
            deletePage: '删除页面',
            submit: '提交',
            ppt: {
                currentSubject: '当前PPT主题',
                prompt: 'prompt（指令）',
                placeHolder:
                    '建议参考当前PPT生成内容的上下文，填写一段具体描述，如：帮我再多补充关于【${0}】的PPT内容。',
                singlePptGenerate: '生成单页PPT',
                tips: {
                    generateSuccess: '生成成功',
                    singlePptGenerating: '正在生成单页PPT...',
                    pptReGenerating: '重新生成第${0}页...',
                    reGenerate: '重新生成',
                },
            },
            replaceComponentTitle: '替换样式',
            changeAnotherComponent: '换一批',
            componentReplaceing: '切换组件中...',
            noComponentTip: '未匹配到相应组件',
        },
        textCollapse: {
            defaultText: '双击编辑文字',
            commonUsed: '常用素材',
            recentUsed: '最近使用',
            clickToAddText: '点击添加文本',
            title: '标题',
            subTitle: '副标题',
            contentText: '正文',
            more: '更多',
            all: '全部',
            messageError: {
                needNewest: '请使用最新的文字素材',
                fetchFailed: '获取素材失败',
            },
            search: {
                placeholder: '搜索文字',
            },
            defaultPPTTextMap: {
                title: '双击编辑标题',
                subTitle: '双击编辑副标题',
                authorAndDate: '作者和日期',
            },
        },
        moreCollapse: {
            componentTool: {
                title: '组件',
                table: {
                    title: '表格',
                    desc: '提供丰富的表格样式，同时支持导入Excel文件。',
                    importExcel: '从Excel导入',
                    importExcelLimit: '仅支持导入${0}行*${1}列的Excel文件',
                    needSelected: '选择样式',
                    messageError: {
                        filetypeLimit: '仅支持.xlsx文件格式哦～',
                    },
                },
                qrCode: {
                    title: '二维码',
                    desc: '支持生成网址或公众号的二维码，同时提供丰富多变的样式。',
                    website: '网址',
                    official: '公众号',
                    needSelected: '选择样式',
                    createQrCode: '创建二维码',
                    uploadQrCode: '上传识别',
                    messageError: {
                        officialInputError: '请输入正确的公众号～',
                        recognitionFailed: '识别失败，请上传正确且清晰的二维码图片',
                    },
                    intlDesc: '支持根据网址生成二维码，并提供多种样式。',
                    intlTabTip: '请输入网址',
                },
            },
            imageModal: {
                title: '使用${0}前，请先选择一张图片~',
                desc: '选择海报模板中的图片 >',
                uploadImage: '上传图片',
                messageError: {
                    uploadFailed: '上传图片失败',
                },
            },
            imageTool: {
                title: '图片工具',
                generate: '生成',
                generating: '生成中',
                result: '生成结果：',
                reGenerate: '再次生成',
                imGenerate: '立即生成',
                image: '图片',
                apply: '应用',
                exit: '退出',
                messageError: {
                    failed: '生成失败',
                    aiFailed: 'AI${0}失败',
                    meidouReturned: '美豆已退回',
                },
                aiExpend: {
                    title: 'AI扩图',
                    desc: '在原图基础上对画面进行拓展，支持多种尺寸选择。',
                    originalRadio: '原比例',
                    sizeTitle: '扩展尺寸',
                    radioTitle: '扩展比例',
                    expend: '扩图',
                    toast: '扩图尺寸超出画布限制，暂时不能继续扩展啦～',
                },
                aiModify: {
                    title: '局部重绘',
                    desc: '输入文字，AI根据描述在指定区域内重新生成图片内容。',
                    internalTest: '内测',
                    promptDefault: '一只土拨鼠',
                    paintTitle: '涂抹选区：',
                    paintDescTitle: '请描述你的创意：',
                    tips: {
                        inputLimit: '最多可输入500个字',
                        inputPlaceholder: '请描述你要修改的画面内容。',
                        guide: '请先涂抹区域和填写创意',
                    },
                    modify: '重绘',
                    reset: '重置',
                },
                imageTranslation: {
                    title: '图片翻译',
                    desc: '翻译图片文本为各国语言并支持编辑，助力跨国营销。',
                    selectOriginalLanguage: '请选择原文语言：',
                    selectTranslation: '请选择译文语言：',
                    translate: '开始翻译',
                    translateAgain: '重新翻译',
                    original: '原文',
                    translation: '译文',
                    translationResult: '翻译结果',
                    noResult: '未在图片中检测到原文语言，请重新选择',
                    fail: '图片翻译失败，重新翻译试试吧～',
                    ok: '我知道了',
                    apply: '确认',
                    cancel: '取消',
                    confirmText: '进行其他操作后，将无法重新翻译图片，确认操作吗？',
                    sameSelect: '原文和译文语言一致，请重新选择',
                },
            },
            textTool: {
                title: '文字工具',
                generate: '生成',
                generating: '生成中',
                result: '生成结果：',
                reGenerate: '再次生成',
                imGenerate: '立即生成',
                aiText: {
                    title: 'AI花字',
                    desc: '更加富有创意的文字特效，非常适合海报标题使用。',
                    generating: 'AI花字生成中',
                    selectedTitle: '精选效果',
                    aiTextDesc: '每次生成1～${0}个字的效果最佳哦',
                    content: '内容',
                    font: '字体',
                    style: '样式',
                    textPreview: '文字预览：',
                    tips: {
                        inputPlaceholder: '请输入花字内容',
                        disclaimer: '免责声明',
                        disclaimerContent:
                            '使用本服务前您须理解，AI产出内容取决于人工智能对大数据的深度学习，不排除其中部分信息可能存在瑕疵、不合理或引发不快之处，故美图对通过算法生成内容的准确性、完整性和功能性等均不做任何保证，亦不承担包括侵犯第三人权利在内的任何法律责任；同时，因为AI设计服务依赖于您个人输入的文字信息生成相关内容，您需自行对输入信息及生成的内容进行理性选择；您须确保，依法使用本服务及其生成的AI作品，不侵犯任何第三方的版权、商标或其他合法权利，不得将生成的作品用于任何非法用途；如因您的不当使用行为导致任何第三方权益受损的，您将依法承担相应法律责任。',
                    },
                    messageError: {
                        needContent: '请输入花字内容',
                        needSelected: '请选择效果',
                        failed: '生成失败，请重新尝试',
                        inputLimit: '最多支持${0}个字哦～',
                    },
                },
            },
            migrateHint: '表格和二维码迁移到添加tab啦',
            batchTool: {
                title: '批量化',
                aiSizeExtend: {
                    title: 'AI尺寸延展',
                    desc: '以当前画布内容进行尺寸拓展，智能变换不同版式。',
                    currentCanvasSize: '当前画布尺寸',
                    unit: '单位',
                    selectDesc: '请选择需要延展的尺寸',
                    free: '限免',
                    width: '宽',
                    height: '高',
                    generateBtnText: '生成${0}个延展页面',
                },
                batchTemplate: {
                    title: '批量套模板',
                    desc: '输入文字/图片即可批量生成相同模板不同内容的海报。',
                    operateTip: '选中画布元素—点击匹配标签—选择标签',
                    changeDataBtnText: '修改数据',
                    generateBtnText: '生成${0}个页面',
                    exitBtnText: '退出批量套模板',
                    clearTableBtnText: '清空表格',
                    nextBtnText: '下一步',
                    cancelBtnText: '取消',
                    conformBtnText: '确认',
                    noInputLabelTip: '请选择标签和填写名称',
                    noMatchLabelTipText: '有标签项尚未匹配，继续生成将会丢失该信息，是否继续？',
                    clearAllDataTipText: '退出批量套模板后，填写的模板信息将会清空，确定退出吗？',
                    max80PageTipText: '超出页面数量80个限制，请调整页面数量后重试',
                    onlyUploadPngJpgTipText: '只能上传jpg或png格式图片',
                    maxFileSizeTipText: '仅支持20M以内的图片',
                    maxImageSizeTipText: '图片宽高不能超过8000像素',
                    inputLabelTypePlaceholder: '请输入标签名称',
                    labelTypeImageName: '图片',
                    labelTypeTextName: '文字',
                    labelTypeNoSelectName: '类型',
                    tableInputLine1: '1、请在首行下拉选择标签类型：文字、图片，并且输入标签名称。',
                    tableInputLine2: '2、选择标签后，请在下方填写对应标签的具体内容或者上传图片。',
                    clearTableTipText: '确定清除当前表格内容吗？',
                    changeLabelTypeClearDataTipText: '切换类型后，已填写信息将会清空，确认切换吗？',
                    noMatchLayerText: '未匹配',
                    isGeneratingText: '生成中...',
                    tipTitle1: '手动输入：',
                    tipTitle2: '上传文件：',
                    tip1: '1、请在标签行，下拉选择标签类型：文字、图片，井且输入标签名称。',
                    tip2: '2、输入标签后，请在页面行填写对应标签的具体内容或上传图片。',
                    tip3: '1、 支持xlsx，xls格式的文件。',
                    tip4: '2、首行将柀识别成标签信息，首行以下的表格内容将柀识别成页面信息。',
                    tip5: '3、上传文件不支持插入图片。',
                    uploadBtn: '上传文件',
                    uploadTip: '上传表格后，将会覆盖已填写的信息，是否继续',
                    uploadFailTip: '请上传正确的文件！',
                    layerOperate: {
                        cover: '填充展示',
                        full: '完整展示',
                    },
                },
            },
            chartTool: {
                title: '图表',
                barName: '柱状图',
                lineName: '折线图',
                pieName: '饼图',
                horizontalBarName: '条形图',
            },
        },
        shortcutCollapse: {
            picture: {
                title: '图片',
                localUpload: '本地上传',
                myPicture: '我的图片',
                more: '更多',
                imageLib: '图片图库',
                addBackground: '添加背景',
            },
            text: {
                menuTitle: '文字',
                title: '标题',
                subTitle: '副标题',
                text: '正文',
                deformedLetters: '变形文字',
                specialEffectText: '特效文字',
                more: '更多',
            },
            Brush: {
                title: '画图',
                more: '更多',
            },
        },
        adjustCollapse: {
            cropTitle: '裁剪/旋转/尺寸',
            sizeAdjustment: '尺寸调整',
            proportionalCrop: '比例裁剪',
            shapeMask: '形状蒙版',
            okText: '确定',
            cancelText: '取消',
            intelligentColor: '一键换色',
            sourceColor: '源颜色',
            sourceColorDesc: '选择图片中的一种颜色',
            colorTolerance: '颜色容差',
            targetColor: '目标颜色',
            targetColorDesc: '需要替换成的颜色',
            eraser: '擦除',
            eraserDesc: '擦除或涂抹目标颜色区域',
            clear: '清空',
            recommendedEffect: '推荐效果',
            resetEffect: '重置效果',
            manualColor: '手动调色',
            hue: '色相',
            saturation: '饱和度',
            brightness: '明度',
            clearEffect: '清除效果',
            noEffectOnEmptyCanvas: '当前功能对创建的空画布不生效哦~',
            addCustomSize: '添加自定义尺寸',
            apply: '应用',
            custom: '自定义',
            lockedScale: '锁定比例',
            unLockedScale: '未锁定比例',
            leftRotate: '左旋转90°',
            rightRotate: '右旋转90°',
            horizontalFlip: '水平翻转',
            verticalFlip: '垂直翻转',
            reset: '重置',
            freeCutting: '自由裁剪',
            px: '像素',
            cm: '厘米',
            cropList: {
                square: '1:1 正方形',
                verticalCamera: '2:3 单反相机(竖)',
                horizontalCamera: '3:2 单反相机(横)',
                standardVerticalScreen: '3:4 标准屏幕(竖)',
                standardHorizontalScreen: '4:3 标准屏幕(横)',
                verticalVideo: '9:16 视频竖屏',
                horizontalVideo: '16:9 视频横屏',
                verticalFullScreen: '9:18 全面屏(竖)',
                horizontalFullScreen: '18:9 全面屏(横)',
                widescreenPhotoAlbum: '5:3 宽屏相册',
            },
            losslessResizing: '无损改尺寸',
            losslessResizingDesc: '提升画面质量，保证清晰度',
        },
        filterCollapse: {
            confirmTitle: '温馨提示',
            confirmContent: '图片已修改,是否应用此效果?',
        },
        watermarkCollapse: {
            addSuccessText: '添加成功',
            onLineError: '网络已断开，请联网后重试',
            all: '全部',
            confirmContent: '目前只允许设置单个水印内容，点击后您当前设置的水印将被替换，是否替换当前水印？',
            confirmNoMind: '不再提示',
            confirmTitle: '提示',
            confirmOk: '确认',
            confirmCancel: '取消',
            materialDetail: '素材专题详情',
            recommendMaterial: '推荐素材',
            recentlyMaterial: '最近使用',
            uploadWatermark: '上传水印',
            limitImageSize: '仅支持20M以内的图片',
        },
        brandLibCollapse: {
            brandTabTitle: '品牌规范',
            templateTabTitle: '模板库',
            textStyleTitle: '文字样式',
            logoTitle: 'logo',
            more: '全部',
            emptyText: '暂无内容',
        },
        mogCollapse: {
            preset: '调色预设',
            reset: '重置效果',
            none: '无',
        },
    },
    panel: {
        backgroundPanel: {
            canvas: '画布',
            canvasSize: '画布尺寸',
            adjustSize: '调整尺寸',
            horizontalFlip: '水平翻转',
            verticalFlip: '垂直翻转',
            canvasBackground: '画布背景',
            restoreBackground: '恢复原始背景',
            width: '宽',
            height: '高',
            replace: '替换',
            crop: '裁剪',
            color: '颜色',
            image: '图片',
            uploadImage: '上传图片',
            cropLimit: '当前背景为平铺背景，不支持裁剪功能',
            splitBackground: '分离背景图',
            opacity: '透明度',
            clickOrDropToUpload: '点击上传图片${0}或拖拽文件到框内上传',
            customSize: '自定义尺寸',
            originalSize: '原尺寸',
            saveSize: '保存尺寸',
            presetSize: '预设尺寸',
            unit: '单位:',
            lockRatio: '锁定宽高比',
            customRatio: '自定义比例',
            smartLayout: '智能排版',
            tips: {
                splitSuccess: '背景已分离成图片',
                deleteConfirm: '确定删除当前尺寸吗？',
                okText: '确定',
                cancelText: '取消',
                deleteSuccess: '删除当前尺寸成功',
                saveSizeSuccess: '自定义尺寸保存成功',
                adjustSizeWouldChangeLayout: '修改后，当前模板排版会产生变化。',
                addToMySize: '添加到我的尺寸',
                add: '添加',
                inputSizeName: '输入尺寸名称',
            },
            messageError: {
                uploadNumLimit: '仅支持上传1张图片',
                canvasSizeLimit: '画布尺寸需在限制范围内',
                saveSizeFailed: '自定义尺寸保存失败',
                autoAdjustedToLimit: '画布尺寸自动调整为限制范围',
            },
            background: '背景',
            imageSize: '图片尺寸',
            backgroundSize: '背景尺寸',
            customSizeTitle: '我的尺寸',
            addSize: '添加',
            recommendSizeTitle: '推荐尺寸',
            currentCanvasSize: '当前画布尺寸',
            aiSizeExtend: 'AI尺寸延展',
            free: '限免',
            smartLayoutTip: '调整大小时保持画布内的元素布局不变',
            recommendColor: '推荐颜色',
            currentBgColor: '当前背景色',
            selectFromBackground: '从背景库选择',
            dynamicPanel: {
                title: '动态背景',
                hiddenLabel: '是否显示',
                open: '开',
                close: '关',
            },
        },
        brushPanel: {
            brush: '画图',
            brushPen: '画笔',
            shape: '形状',
            style: '样式',
            stroke: '描边',
            color: '颜色',
            endpoint: '端点',
            opacity: '透明度',
            radius: '圆角',
            thickness: '粗细',
        },
        groupPanel: {
            multiSelect: '多选',
            group: '组合',
            makeGroup: '组合',
            breakGroup: '取消组合',
            mergeLayer: '合并图层',
            tips: {
                breakGroupVipLimit: '付费素材不支持解组使用',
                mergeConfirm: '合并后，所选图层将变为一张图片，确认合并吗?',
                okText: '合并',
                cancelText: '取消',
            },
        },
        imagePanel: {
            image: '图片',
            aiImage: 'AI图片',
            imageSetting: '图片设置',
            imageAdjust: '调色',
            baseImageAdjust: '基础调色',
            advancedImageAdjust: '高级调色',
            adjustLight: '光效',
            adjustColor: '色彩',
            adjustParticulars: '细节',
            adjustPosterize: '色调分离',
            adjustHsl: 'HSL',
            effect: '特效',
            imageEliminatePen: '消除笔',
            cancel: '取消',
            complete: '完成',
            undo: '撤销',
            redo: '重做',
            reset: '重置',
            delete: '删除',
            exit: '退出',
            imageFilter: '滤镜',
            imageMask: '蒙版',
            aiGenerateImageTitle: 'AI图片画面描述',
            aiGenerateImageDesc: '您可以根据需求调整当前素材${0}的画面描述，风格，色彩效果',
            inputPlaceholder: '请输入',
            generatingImage: '我们正努力把您脑海中的设想呈现出来，请耐心等待一会～',
            reGenerate: '重新生成',
            cutoutMemberLimit: '抠图张数不足，开通会员送张数',
            cutoutRechargeLimit: '抠图张数不足，请先充值',
            monthMemberPresent: '月会员送 50张/月',
            seasonMemberPresent: '季会员送 250张/季',
            yearMemberPresent: '年会员送 1200张/年',
            activateMember: '立即开通',
            discountedPrice: '优惠低至¥0.16元/张',
            permanentlyValid: '张数永久有效',
            rechargeNow: '立即充值',
            replaceImage: '替换图片',
            imageCrop: '裁剪',
            imageCutout: '抠图',
            opacity: '透明度',
            pasterDesc: '使用截图工具后${0}在此粘贴图片',
            import: '导入',
            mySpace: '我的空间',
            teamMaterial: '团队素材',
            selectedPhoto: '精选照片',
            importClipboard: '本地上传',
            addImage: '添加图片',
            unnamed: '未命名',
            format: '格式：',
            size: '尺寸：',
            tips: {
                uploadSuccess: '上传成功',
                uploadLimit: '仅支持20M以内的图片',
                deleteTitle: '删除提示',
                deleteDesc: '删除后将无法重新找回，请谨慎操作',
                okText: '确认删除',
                cancelText: '取消',
                deleteSuccess: '删除成功',
                selected: '已选择 <></> 条',
                noMaterial: '暂无内容，点击添加素材上传',
                matting: '抠图中...',
                bathAdd: '批量添加',
            },
            messageError: {
                generateFailed: '生成图片失败',
                networkError: '您的网络发生异常，无法连接服务器',
                importFailed: '导入失败',
                filetypeLimit: '仅支持jpg,png,heic,svg图片',
                uploadFailed: '上传失败',
            },
            share: {
                uploadImage: '上传图片',
                uploadTip: '点击/拖拽/粘贴图片至此处',
                imageTip: '支持上传20M以内JPG、JPEG、PNG，最多支持${0}张',
                bathAdd: '批量添加',
                imageTipText: '支持上传20M以内JPG、JPEG、PNG',
                uploadCountTip: '最多支持添加${0}张图片哦～',
            },
            removeBgTip: '点击这里去除背景哦',
            imageEliminatePenButton: '消除笔',
            productRetouching: '商品修图',
            imageAIExpand: '扩图',
            imageMore: '更多',
            imageGenerate: 'AI生图',
            imageModify: '局部重绘',
            imageQuality: '变清晰',
            imageTranslation: '图片翻译',
            imageUpscale: '无损改尺寸',
        },
        qrCodePanel: {
            qrCode: '二维码',
            style: '样式',
            color: '颜色',
            opacity: '透明度',
            backgroundColor: '背景色',
            qrCodeColor: '二维码颜色',
            website: '网址',
            official: '公众号',
            websitePlaceholder: '在此输入网址',
            officialPlaceholder: '在此输入公众号',
            uploadIdentify: '上传识别',
            updateQrCode: '更新二维码',
            selectStyle: '请选择样式',
            messageError: {
                websiteInputError: '请输入正确的网址～',
                officialInputError: '请输入正确的公众号～',
                recognitionFailed: '识别失败，请上传正确且清晰的二维码图片',
            },
        },
        tablePanel: {
            table: '表格',
            opacity: '透明度',
            textStyle: '文字样式',
        },
        textPanel: {
            text: '文字',
            style: '风格',
            normal: '常规',
            textEffect: '文字特效',
            textTransform: '文字变形',
            advanceSetting: '高级设置',
            textStyle: '文字样式',
            transform: '变形',
            messageError: {
                generateFailed: '生成文字失败',
            },
            textMark: '划重点',
        },
        vectorPanel: {
            vectorShape: '图形',
            style: '样式',
            stroke: '描边',
            color: '颜色',
            opacity: '透明度',
            radius: '圆角',
            thickness: '粗细',
            blur: '模糊',
            vectorEffect: '图形特效',
            effect: {
                shadow: '阴影',
                reflection: '倒影',
                stroke: '描边',
                distance: '距离',
                size: '大小',
            },
            modalTitle: '设置',
        },
        watermarkPanel: {
            openTile: '开启平铺',
            closeTile: '关闭平铺',
            watermarkText: '水印文案',
            placeholderText: '请输入文本',
            watermarkSize: '水印大小',
            watermarkSpace: '水印间距',
            watermarkCross: '水印交错',
            watermarkRotate: '水印旋转',
            requireLogin: '请先登录账号后上传图片',
            limitImageSize: '仅支持20M以内的图片',
            replace: '替换',
            watermark: '水印',
            settingStyle: '样式设置',
            onlySupport: '仅支持在水印板块下对平铺样式进行设置',
            opacity: '不透明度',
            fontColor: '字体颜色',
            tileDisplay: '平铺展示',
        },
        markupPanel: {
            brush: '画图',
            label: '尺寸文案',
            type: '类型',
            num: '数值',
            custom: '自定义文案',
            unit: '单位',
            unitPlaceholder: '选择单位',
            unitTip: '单位多选时，以最小单位进行换算和展示。如：100mm/10cm/3.94inch',
            text: '文案',
            textPlaceholder: '输入尺寸文案',
            position: '位置',
            up: '线条上方',
            center: '线条中间',
            down: '线条下方',
            rotate: '角度',
            fontFamily: '字体',
            fontSize: '字号',
            style: '样式',
            background: '背景色',
            stroke: '描边',
            color: '颜色',
            thickness: '粗细',
            endpoint: '端点',
            line: '显示延长线',
            opacity: '透明度',
            segment: '指引文案',
            lineStyle: '线条样式',
            angle: '角度文案',
            angleArea: '角度区域',
        },
        mediaPanel: {
            media: '动态素材',
            opacity: '透明度',
            posterPlaceholder: '在此输入视频封面地址',
            videoUrlPlaceholder: '在此输入视频地址',
            updatePoster: '更新封面',
            updateVideoUrl: '更新视频地址',
            posterInputError: '请输入正确的视频封面地址',
            videoUrlInputError: '请输入正确的视频地址',
        },
        productRetouchingPanel: {
            common: '通用商品',
            hardware: '五金制品',
            cosmetic: '化妆品',
            leatherProducts: '皮制品',
            pending: '处理中',
            failed: '处理失败，请重试~',
            limit: '已达今日试用上限，开通会员不受限！',
            activateCancel: '明日再来',
            activateMember: '立即开通',
        },
    },
    layers: {
        text: '文字',
        image: '图片',
        vector: '图形',
        background: '背景',
        group: '组合',
        qrCode: '二维码',
        table: '表格',
        brush: '画笔',
    },
    hooks: {
        useNetWork: {
            onLine: '网络已重新连接',
            unOnLine: '网络错误：请重试或检查您的网络状态',
        },
        uploadMaxLimit: '仅支持批量上传10张图片',
        common: '通用',
        designFileName: '未命名的设计',
        reasonToDefaultTemplate: '${0}，改成请求默认模板',
        failedToDefaultTemplate: '模板请求失败，改成请求默认模板',
        fontsRemoved: '${0} 字体已下架，已帮您替换成默认字体',
        loadFailed: '加载模板失败',
        editOnLeft: '左侧编辑花字',
        generationCompleted: '生成完成',
        generating: '正在创建第${0}页...(${1}/${2})',
        functionalFailure: '功能故障',
        jumpToRecord: '3秒后跳转到个人作图记录',
        notLatestRecord: '当前作图不是最新版本，请刷新后重新操作',
        refresh: '刷新',
        cancel: '取消',
        tryAgainLater: '操作太快了，请稍后再试',
        uploadFailed: '作图记录上传失败，请重新上传',
        failedToSave: '作图记录保存失败',
        failedToLoadRecord: '加载作图记录失败',
        textMaterialHide: '已自动移除不兼容的文字素材',
    },
    menu: {
        template: '模板',
        bg: '背景',
        text: '文字',
        material: '素材',
        draw: '画图',
        pic: '图片',
        space: '空间',
        pages: '页面',
        more: '更多',
        team: '团队',
        add: '添加',
        mine: '我的',
        filter: '滤镜',
        waterMark: '水印',
        adjust: '调整',
        brandLib: '品牌',
        element: '元素',
        mog: '调色',
    },
    'ie-tip': {
        title: '当前浏览器可能存在兼容性问题，为保证正常使用美图设计室功能，建议您更换浏览器。',
        cancelText: '继续使用',
        okText: '我知道了',
    },
    extensions: {
        refreshAndTryAgain: '打开异常，请刷新重试',
        dragToAdjust: '拖拽移动产品图位置、大小和角度哦～',
        clickToReplace: '双击图片，替换产品图哦～',
        aiQuality: {
            title: '变清晰',
            desc: '超清画质重生，告别渣画质。',
            aiQualityLevel: '请选择变清晰程度：',
            hd: '高清',
            hdu: '超清',
            improving: '画质提升中...',
            sd: '标清',
        },
        aiMatting: {
            title: '智能抠图',
            aiMattingType: '识别类型：',
            none: '无',
            human: '人像宠物',
            thing: '商品货物',
            icon: '图标印章',
            advanceEdit: '高级编辑：',
            mattingOptimize: '抠图优化',
            matting: '抠图中...',
            mattingFailed: '未识别到人像/物品/图标',
            desc: '3秒一键抠图，快速去除背景。',
            loading: '加载中…',
        },
        reset: '重置',
        okText: '确定',
        cancelText: '取消',
        aiUpscale: {
            title: '无损改尺寸',
            desc: '缩放图片，清晰不失真。',
            improving: '无损改尺寸中...',
            errorCode2: '图片地址为空！',
            errorCode3: '请至少选择或输入一个尺寸！',
            errorCode4: '请填写正确的尺寸！',
            errorCode5: '已达今日试用上限，开通会员不受限！',
            errorCode7: '生成失败',
            errorCode8: '请求超时，请重试！',
            errorCode9: '生成失败，请联系客服。',
            activateCancel: '明日再来',
            activateMember: '立即开通',
        },
        commercial: {
            outLimit: '您今日的使用次数已达上限，明天再来吧！',
            know: '我知道了',
            freeErrorMessage: '今日免费次数已达上限，开通会员不受限！',
            onText: '立即开通',
            tomorrow: '明日再来',
            noRulersError: '生成失败，请联系客服。',
            nonVipForeverErrorMessage: '您的免费次数使用已达上限，开通会员不受限！',
        },
    },
    guidePopover: {
        addEntryTip: '点击此处添加各类素材哦～',
    },
    globalMask: {
        loading: '加载中...',
    },
    textFontSizeAndTextColor: {
        size: '字号',
    },
};
